import { Box, Grid, styled, SwipeableDrawer, useMediaQuery, useTheme } from '@mui/material'
import apiManagerUser from 'api/manager-users'
import SidebarCC from 'components/Layout/SidebarCC'
import { HEIGHT_COMPONENTS } from 'constants/ui.contants'
import { USER_PROPERTIES } from 'constants/user'
import useCheck2FaStatus from 'hooks/useCheck2FaStatus'
import { ContentOutlet } from 'layouts'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import NavigationProvider from 'shared/navigate/NavigationProvider'
import { color } from 'theme'
import { getUserProperty } from 'utils/helpers'
import AppBar from './AppBar'
import { useSelector } from 'react-redux'

const ContentWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    height: `calc(100dvh - ${HEIGHT_COMPONENTS.HEADER})`
}))

const MainLayout = () => {
    const navigate = useNavigate()
    const { handleOpenDilogActive2Fa } = useCheck2FaStatus(navigate)
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [mobileOpen, setMobileOpen] = useState(false);
    const username = getUserProperty(USER_PROPERTIES.USERNAME)
    const disabledSidebar = useSelector((state) => state.layout.disabledSidebar)

    const handleDrawerToggle = () => {
        if (!disabledSidebar) {
            setMobileOpen(!mobileOpen);
        }
    };

    useEffect(() => {
        const get2FAStatus = async () => {
            try {
                if (username) {
                    const res = await apiManagerUser.current2FA()

                    if (res?.code === 0) handleOpenDilogActive2Fa(res.data)
                }
            } catch (error) {
                console.log(error)
            }
        }

        get2FAStatus()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Grid container>
            <Grid item xs={12} sx={{ pointerEvents: disabledSidebar ? 'none' : 'auto' }}>
                <AppBar onMenuClick={handleDrawerToggle} />
            </Grid>

            <Grid item xs={12}>
                <ContentWrapper id='conten-wrapper'>
                    <Box sx={{ pointerEvents: disabledSidebar ? 'none' : 'auto' }}>
                        {isMobile ? (
                            <SwipeableDrawer
                                anchor="left"
                                open={mobileOpen}
                                onClose={handleDrawerToggle}
                                onOpen={handleDrawerToggle}
                                sx={{
                                    '& .MuiDrawer-paper': {
                                        width: '40vw',
                                        minWidth: '150px',
                                        boxSizing: 'border-box',
                                        backgroundColor: color.greyIL06,
                                    },
                                }}
                            >
                                <SidebarCC isMobile={true} onClose={handleDrawerToggle} />
                            </SwipeableDrawer>
                        ) : (
                            <SidebarCC isMobile={false} />
                        )}
                    </Box>
                    <ContentOutlet />
                </ContentWrapper>
            </Grid>
            <NavigationProvider />
        </Grid>
    )
}

export default MainLayout